import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { isEditActiveSelector } from "../../../reducers/editReducer";
import * as React from "react";
import EditParameter from "../../Editing/EditParameter";
import { Dimmer } from "semantic-ui-react";
import Table from "../../../components/Table/Table";
import { setParameterExtraProperties } from "../../../utils/pdApiUtils";
import { EditActions, editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { mainActions, MainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
type StateProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  subMenuRoute: State.SafetySubmenu;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.SafetySubmenu, columnFilter: Filter[]) => void;
}

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
};

type OwnProps = {
  toggleModal: () => void;
  isLoadingParameters: boolean;
};

export type SafetyParametersTableProps = StateProps & DispatchProps & OwnProps;

type SafetyParametersTableState = {
  isModalOpen: boolean;
};

export class SafetyParametersTable extends React.Component<
  SafetyParametersTableProps,
  SafetyParametersTableState
> {
  state = {
    isModalOpen: false
  };

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  render(): JSX.Element {
    const {
      columns,
      pdApi,
      mainState,
      isEditActive,
      toggleModal,
      isLoadingParameters
    } = this.props;
    const { safetyParameters } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let parameterRows: Api.AnyParameter[] = [];
    let selectedColumns: State.Column[] = [];

    parameterRows = safetyParameters;
    parameterRows = parameterRows.map(row => setParameterExtraProperties(row, pdApi));
    selectedColumns = columns["Safety Parameters"];

    // Add submenu specific columns and rows
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            rows={parameterRows}
            loading={isLoadingParameters}
            loadingText="Fetching safety parameters..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isParameterSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditParameter toggleModal={toggleModal} groupName="Safety" columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }
  /**
   * Returns status if parameter has been selected
   * @param {Api.AnyParameter} fault
   * @returns {boolean}
   */
  private isParameterSelected = (parameter: Api.AnyParameter): boolean => {
    const { editedObjectId } = this.props;
    if (editedObjectId && parameter.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  mainState: state.main,
  isEditActive: isEditActiveSelector(state.editView)
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions | MainActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SafetyParametersTable);
